import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const orderApi = createApi({
	reducerPath: 'orderApi',
	baseQuery: customBaseQuery,
	tagTypes: ['Order'],
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		// POST /api/order/create
		createOrder: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/create',
				method: 'POST',
				body: data,
				schema,
				prefix: 'order',
			}),
			invalidatesTags: ['Order'],
		}),

		// GET /api/order/all
		getAllOrders: builder.query({
			query: ({ params = {}, schema }) => ({
				url: '/all',
				method: 'GET',
				params,
				schema,
				prefix: 'order',
			}),
			providesTags: ['Order'],
		}),

		// GET /api/order/:id
		getOrderById: builder.query({
			query: ({ id, schema }) => ({
				url: `/${id}`,
				method: 'GET',
				schema,
				prefix: 'order',
			}),
			providesTags: (result, error, { id }) => [{ type: 'Order', id }],
		}),

		// DELETE /api/order/:id
		deleteOrderById: builder.mutation({
			query: ({ id, schema }) => ({
				url: `/${id}`,
				method: 'DELETE',
				schema,
				prefix: 'order',
			}),
			invalidatesTags: ['Order'],
		}),

		// PUT /api/order/:id
		updateOrder: builder.mutation({
			query: ({ id, data, schema }) => ({
				url: `/${id}`,
				method: 'PUT',
				body: data,
				schema,
				prefix: 'order',
			}),
			invalidatesTags: (result, error, { id }) => [{ type: 'Order', id }],
		}),

		// POST /api/order/botMesg
		sendBotMessage: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/botMesg',
				method: 'POST',
				body: data,
				schema,
				prefix: 'order',
			}),
		}),

	}),
});

export const {
	useCreateOrderMutation,
	useGetAllOrdersQuery,
	useGetOrderByIdQuery,
	useDeleteOrderByIdMutation,
	useUpdateOrderMutation,
	useSendBotMessageMutation,
} = orderApi;
